import React from "react";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { HRService } from "../../../../config";
import {
  generateAndExecuteMutation,
} from "../../../../data/Axios/DynamicService";

const base_url = HRService.uri;

const PracticeGroupForm = (props) => {
  const initialValues = {
    name: props.data ? props.data.name : "",
  };

  const fields = [
    {
      name: "name",
      label: "Practice Group Name",
      type: "text",
      required: true,
      gridColumn: "span 2",
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Fetch user ID from token for createdBy / updatedBy
      const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
      const userId = decodedToken?.Id ? parseInt(decodedToken.Id) : null;

      // Prepare correct data payload for GraphQL
      const mutationData = {
        id: props.isEditing ? props.data.id : 0, // required for both create & update
        name: values.name,
        createdBy: props.isEditing ? null : userId,
        updatedBy: props.isEditing ? userId : null,
      };

      // Choose correct mutation name
      const mutationName = props.isEditing
        ? "updatePracticeGroup"
        : "createPracticeGroups";

      // Execute mutation (GraphQL argument must be 'group')
      const response = await generateAndExecuteMutation(
        mutationName,
        mutationData,
        "group",
        base_url
      );

      // If successful
      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: props.isEditing
            ? "Practice Group updated successfully."
            : "Practice Group created successfully.",
        });
      }
    } catch (error) {
      console.error("Error submitting Practice Group:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={[{
        stepNumber: 1,
        stepLabel: "Practice Group",
        stepDescription: "Enter a practice group",
        fields: fields.map(f => f.name),
      }]}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Update Practice Group" : "Create Practice Group"}
      subtitle={
        props.isEditing
          ? "Update existing practice group details."
          : "Fill out the form below to create a new practice group."
      }
    />
  );
};

export default PracticeGroupForm;
